import React from "react";
import "../../styles/facilitatorKRAView.scss";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import MultiSelectAll from "../../common/Multiselect/MultiSelectAll";
import ReactDatePicker from "react-datepicker";
import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import Chart from "react-google-charts";
import ManagersFacilitatorKRAGrid from "../../components/FacilitatorKRADashboard/ManagersFacilitatorKRAGrid.jsx"


export default function ManagersFacilitatorKRADashboardContainer(props)
{
    const [isLoading, setIsLoading] = useState(false);
    const[activePage,setActivePage]=useState(""); 
    const history = useHistory();

    const [selectedMonthForFilter, setMonthForFilter] = useState(new Date());
    const [FacilitatorNameListForFilter, setFacilitatorNameListForFilter] = useState([]);
    const [selectedFacilitatorNameListForFilter, setSelectedFacilitatorNameListForFilter] = useState([]);
    const [FacilitatorData,setFacilitatorData] =useState([]);
    const [TableData,setTableData] =useState([]);
    const Data = [];

    const[teamsPerformanceDeliveredTarget,setteamsPerformanceDeliveredTarget]=useState(0);
    const[teamsPerformanceDeliveredAchieved,setteamsPerformanceDeliveredAchieved]=useState(0);
    const[teamsPerformance3plusUsersTarget,setteamsPerformance3plusUsersTarget]=useState(0);
    const[teamsPerformance3plusUsersAchieved,setteamsPerformance3plusUsersAchieved]=useState(0);
    const[teamsPerformanceAssignedCount,setteamsPerformanceAssignedCount]=useState(0);
    const[teamsPerformanceDeliveredCount,setteamsPerformanceDeliveredCount]=useState(0);
    

    useEffect(() => {
        if (!getUser()) 
        {
			history.push("/login");
		}
        else
        {
            const user = getUser();
            const hasFacilitatorKRARole = user.role.includes(10);
            if (hasFacilitatorKRARole) 
            {
                setActivePage("ManagersKRAView");
                api.getActiveHHAndFacilitator().then(({ data }) => {

                    let AllUsers=[];
                    let facilitators=[];

                     Object.keys(data).map((e) => {
                        AllUsers.push(e);
                    });

                    /*api.getAllHandholders().then(({ data }) => {
                      Object.keys(data).map((hh) => {
                          if(!AllUsers.includes(hh))
                          {
                            AllUsers.push(hh);
                          }
                        });

                        AllUsers.map((e) => 
                        {
                            facilitators.push({
                                label: e,
                                id: e,
                                value: e,
                            });
                        });
                        
                        setFacilitatorNameListForFilter(facilitators);

                        let temp =[{label: "All", value: "*"}];
                        let tempSR = facilitators.map((e) => 
                        {
                            if (!temp.includes(e)) 
                            {
                                temp = temp.concat(e);
                            }
                            return e;
                        });
                        setSelectedFacilitatorNameListForFilter(temp);

                    });*/

                    AllUsers.map((e) => 
                        {
                            facilitators.push({
                                label: e,
                                id: e,
                                value: e,
                            });
                        });
                        
                        setFacilitatorNameListForFilter(facilitators);

                        let temp =[{label: "All", value: "*"}];
                        let tempSR = facilitators.map((e) => 
                        {
                            if (!temp.includes(e)) 
                            {
                                temp = temp.concat(e);
                            }
                            return e;
                        });
                        setSelectedFacilitatorNameListForFilter(temp);
                });
            }
            else
            {
                setActivePage("No_Access");
            } 
        }
	},[]);

    useEffect(() => {
        getESPServiceData();
	},[FacilitatorNameListForFilter]);

    useEffect(() => {
        setData();
	},[FacilitatorData,selectedFacilitatorNameListForFilter]);

    const toggleAllForFilter = () => 
	{
		let temp =[];
		
		if (selectedFacilitatorNameListForFilter.length != FacilitatorNameListForFilter.length && selectedFacilitatorNameListForFilter.length!=(FacilitatorNameListForFilter.length+1)) 
		{
			if(selectedFacilitatorNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedFacilitatorNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = FacilitatorNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedFacilitatorNameListForFilter(temp);
			//setFacilitatorNameListForFilter(tempSR);
		} 
		else
		{
			setSelectedFacilitatorNameListForFilter([]);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedFacilitatorNameListForFilter(e);
	};

    const handleSearchClick = async () => {
        getESPServiceData();
	};

    const getESPServiceData=()=>{
        let filterParameters = {};
        
        var date = new Date(selectedMonthForFilter);
        var fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
        var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        if(fromDate)
        {
            filterParameters.fromDate=fromDate;
        }

        if(toDate)
        {
            filterParameters.toDate=adjustedToDate(toDate);
        }

        let stesc=filterParameters;
        setIsLoading(true);	
        const { tempServices } = api.getFacilitatorManagersKRADashboardData(filterParameters).then(({ data }) => {
            setIsLoading(false);
			if(data)
            {
                setFacilitatorData(data);
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
		}).catch((error) =>
        {
            setIsLoading(false);
            if(error.response.data.detail)
            {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if(error.response.data.message)
            {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else
            {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }            
        });
    }

    const setData=()=>{
        
        if(FacilitatorData.length>0)
        {
            let fCount=0;
            let teamsPerformanceDeliveredTargetCount=0;
            let teamsPerformance3plusUsersTargetCount=0;
            let teamsPerformanceDeliveredAchievedCount=0;
            let teamsPerformanceAssignedCounttemp=0;
            let teamsPerformanceDeliveredCountTemp=0;
            let teamsPerformance3plusUsersCountTemp=0;
            Data.length=0;
            let arr_IHH =  { key:"",reportType:"IHH", Title:"",target:""}; 
            let arr_total_ticket_assigned =  { key:"total_ticket_assigned",reportType:"", Title:"Total tickets assigned",target:"NA"}; 
            //let arr_target =  { key:"target",reportType:"", Title:"Target",target:"NA"}; 
            //let arr_targeted_vs_achieved =  { key:"targeted_vs_achieved",reportType:"", Title:"Target vs Achieved",target:"NA"}; 
            let arr_total_ticket_unhandled =  { key:"total_ticket_unhandled",reportType:"", Title:"Unhandled tickets",target:"0"}; 
            let arr_total_ticket_unhandled_per =  { key:"total_ticket_unhandled_per",reportType:"", Title:"% of unhandled tickets against total assigned tickets",target:"0%"}; 
            let arr_system_updates_count =  { key:"system_updates_count",reportType:"", Title:"System updates (No. of leads not updated)",target:"0"}; 
            let arr_quality_analysis_fatal_count =  { key:"quality_analysis_fatal_count",reportType:"", Title:"Quality Analysis (No. of Fatal calls)",target:"0"}; 
            let arr_EngagementKRA =  { key:"",reportType:"Engagement KRA", Title:"",target:""}; 
            let arr_assigned_customers =  { key:"assigned_customers",reportType:"", Title:"Assigned Service Requests",target:""}; 
            let arr_intro_call_done =  { key:"intro_call_done",reportType:"", Title:"Introductory call done",target:"100% of assigned Users"}; 
            let arr_intro_call_not_done =  { key:"intro_call_not_done",reportType:"", Title:"Introductory call not done",target:""}; 
            let arr_deprenuer_listed_users =  { key:"deprenuer_listed_users",reportType:"", Title:"How many users listed on deprenuer listing page out of delivered in that period",target:"100% of delivered Users Nearer to 100%"}; 
            let arr_challenges_shared_customer =  { key:"challenges_shared_customer",reportType:"", Title:"How many users shared their challenged/goals with us  out of assigned in that period",target:"100% of assigned Users Nearer to 100%"}; 
            let arr_stay_engaged_customer =  { key:"stay_engaged_customer",reportType:"", Title:"How many users wants to stay engage with us out of delivered Users count",target:""}; 
            let arr_Offerings =  { key:"",reportType:"Offerings", Title:"",target:""}; 
            let arr_no_of_services_delivered_per_month_per =  { key:"no_of_services_delivered_per_month_per",reportType:"", Title:"Target for a month (No of services delivered)",target:"45% of assigned services"}; 
            let arr_delivered_services_target_vs_achieved =  { key:"delivered_services_target_vs_achieved",reportType:"", Title:"Delivered Services Target vs Achieved %",target:""}; 
            let arr_services_delivered_month =  { key:"services_delivered_month",reportType:"", Title:"No of services delivered in a month",target:""}; 
            let arr_Two_resourses_availed_users =  { key:"arr_two_resourses_availed_users",reportType:"", Title:"No of Users availed 2+ resources in a month",target:"NA"}; 
            //let arr_no_of_users_availed_3_plus_services =  { key:"no_of_users_availed_3_plus_services",reportType:"", Title:"Target for a month (No of Users availed 3+ resources)",target:"11 repeat users per month"}; 
            let arr_three_resourses_availed_users =  { key:"arr_three_resourses_availed_users",reportType:"", Title:"No of Users availed 3+ resources in a month",target:"11 repeat users per month"}; 
            let arr_three_resourses_availed_users_target_vs_achieved =  { key:"three_resourses_availed_users_target_vs_achieved",reportType:"", Title:"Three+ resource availed users Target vs Achieved",target:""}; 
    
            selectedFacilitatorNameListForFilter.map((d) => {
                if(d.value!="*")
                {
                    FacilitatorData.map((e) => {
                        if(d.value===e.facilitator_email)
                        {
                            if(e.is_facilitator)
                            {
                                fCount=fCount+1;
                                teamsPerformanceDeliveredTargetCount=teamsPerformanceDeliveredTargetCount+(e["delivered_target"]&&parseFloat(e["delivered_target"])||0);
                                teamsPerformance3plusUsersTargetCount=teamsPerformance3plusUsersTargetCount+(e["three_plus_user_target"]||0);
                                teamsPerformanceDeliveredAchievedCount=teamsPerformanceDeliveredAchievedCount+parseFloat((parseFloat(e["no_of_services_delivered_per_month_per"]).toFixed(2)));
                                teamsPerformanceAssignedCounttemp=teamsPerformanceAssignedCounttemp+parseFloat(e["total_ticket_assigned"]);
                                teamsPerformanceDeliveredCountTemp=teamsPerformanceDeliveredCountTemp+parseInt(e["services_delivered_month"]);
                                teamsPerformance3plusUsersCountTemp=teamsPerformance3plusUsersCountTemp+parseInt(e["three_resourses_availed_users"]);
                            }
                            

                            var sername=e.facilitator_email.replace(/ /g, '').replace(/\./g,'');
                            arr_IHH={...arr_IHH,[sername]:""};
                            arr_total_ticket_assigned={...arr_total_ticket_assigned,[sername]:e["total_ticket_assigned"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],[sername+"target"]:e["target"]||0};
                            //arr_target={...arr_target,[sername]:e["target"]||0,[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            //arr_targeted_vs_achieved={...arr_targeted_vs_achieved,[sername]:e["target"]||0,[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],[sername+"target"]:e["target"]||0,[sername+"achieved"]:(parseInt(e["total_ticket_assigned"]||0)-parseInt(e["total_ticket_unhandled"]||0))};
                            arr_total_ticket_unhandled={...arr_total_ticket_unhandled,[sername]:e["total_ticket_unhandled"]};
                            arr_total_ticket_unhandled_per={...arr_total_ticket_unhandled_per,[sername]:parseFloat(e["total_ticket_unhandled_per"]).toFixed(2).toString()+'%',[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_system_updates_count={...arr_system_updates_count,[sername]:e["system_updates_count"]};
                            arr_quality_analysis_fatal_count={...arr_quality_analysis_fatal_count,[sername]:e["quality_analysis_fatal_count"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:(e["service_instance_ids"].toString().replace(/,/g, '\n'))};
                            arr_EngagementKRA={...arr_EngagementKRA,[sername]:"",[sername+'fataldetails']:"",[sername+"serinstanceids"]:""};
                            arr_assigned_customers={...arr_assigned_customers,[sername]:e["assigned_customers"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_intro_call_done={...arr_intro_call_done,[sername]:e["intro_call_done"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_intro_call_not_done={...arr_intro_call_not_done,[sername]:e["intro_call_not_done"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_deprenuer_listed_users={...arr_deprenuer_listed_users,[sername]:e["deprenuer_listed_users"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_challenges_shared_customer={...arr_challenges_shared_customer,[sername]:e["challenges_shared_customer"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_stay_engaged_customer={...arr_stay_engaged_customer,[sername]:e["stay_engaged_customer"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_Offerings={...arr_Offerings,[sername]:"",[sername+'fataldetails']:"",[sername+"serinstanceids"]:""};
                            arr_no_of_services_delivered_per_month_per={...arr_no_of_services_delivered_per_month_per,[sername]:parseFloat(e["no_of_services_delivered_per_month_per"]).toFixed(2).toString()+'%',[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],target:(e["delivered_target"]?e["delivered_target"]+'% of assigned services':'NA')};
                            arr_delivered_services_target_vs_achieved={...arr_delivered_services_target_vs_achieved,[sername]:e["target"]||0,[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],[sername+"deliveredtarget"]:e["delivered_target"]&&parseFloat(parseFloat(e["delivered_target"]).toFixed(2))||0,[sername+"deliveredachieved"]:parseFloat((parseFloat(e["no_of_services_delivered_per_month_per"]).toFixed(2)))};
                            arr_services_delivered_month={...arr_services_delivered_month,[sername]:e["services_delivered_month"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            //arr_no_of_users_availed_3_plus_services={...arr_no_of_users_availed_3_plus_services,[sername]:e["no_of_users_availed_3_plus_services"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"]};
                            arr_Two_resourses_availed_users={...arr_Two_resourses_availed_users,[sername]:e["two_resourses_availed_users"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],[sername+"tworesoursesavaileduseremails"]:e["two_resourses_availed_user_emails"],target:(e["two_plus_user_target"]?e["two_plus_user_target"]+' repeat users per month':'NA')};
                            arr_three_resourses_availed_users={...arr_three_resourses_availed_users,[sername]:e["three_resourses_availed_users"],[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],[sername+"threeresoursesavaileduseremails"]:e["three_resourses_availed_user_emails"],target:(e["three_plus_user_target"]?e["three_plus_user_target"]+' repeat users per month':'NA')};
                            arr_three_resourses_availed_users_target_vs_achieved={...arr_three_resourses_availed_users_target_vs_achieved,[sername]:e["target"]||0,[sername+'fataldetails']:e["quality_analysis_fatal_details"],[sername+"serinstanceids"]:e["service_instance_ids"],[sername+"threeuserstarget"]:parseInt(e["three_plus_user_target"])||0,[sername+"threeusersachieved"]:parseInt(e["three_resourses_availed_users"])};
                        }
                    });
                }
            });

            setteamsPerformanceDeliveredTarget(parseFloat(parseFloat(teamsPerformanceDeliveredTargetCount/fCount).toFixed(2)));
            setteamsPerformanceDeliveredAchieved(parseFloat(parseFloat(teamsPerformanceDeliveredAchievedCount/fCount).toFixed(2)));
            setteamsPerformance3plusUsersTarget(parseInt(teamsPerformance3plusUsersTargetCount/fCount));
            setteamsPerformance3plusUsersAchieved(parseInt(teamsPerformance3plusUsersCountTemp/fCount));
            setteamsPerformanceAssignedCount(teamsPerformanceAssignedCounttemp);
            setteamsPerformanceDeliveredCount(teamsPerformanceDeliveredCountTemp);
            
    
            Data.push(arr_IHH);
            Data.push(arr_total_ticket_assigned);
            //Data.push(arr_target);            
            Data.push(arr_total_ticket_unhandled);
            //Data.push(arr_targeted_vs_achieved);
            Data.push(arr_total_ticket_unhandled_per);
            Data.push(arr_system_updates_count);
            Data.push(arr_quality_analysis_fatal_count);
            Data.push(arr_EngagementKRA);
            Data.push(arr_assigned_customers);
            Data.push(arr_intro_call_done);
            Data.push(arr_intro_call_not_done);
            Data.push(arr_deprenuer_listed_users);
            Data.push(arr_challenges_shared_customer);
            Data.push(arr_stay_engaged_customer);
            Data.push(arr_Offerings);
            Data.push(arr_no_of_services_delivered_per_month_per);
            Data.push(arr_delivered_services_target_vs_achieved);
            Data.push(arr_services_delivered_month);
            Data.push(arr_Two_resourses_availed_users);
            //Data.push(arr_no_of_users_availed_3_plus_services);
            Data.push(arr_three_resourses_availed_users);
            Data.push(arr_three_resourses_availed_users_target_vs_achieved);
            const finalData=Data
            setTableData(finalData);
        }
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    const downloadComponentInPDF=()=>{
         try
         {
            setIsLoading(true);
            const Component =document.getElementById('root-element');
            html2canvas(document.getElementById('root-element')).then((canvas) => {
              const componentWidth = Component.offsetWidth
              const componentHeight = Component.offsetHeight
          
              const orientation = componentWidth >= componentHeight ? 'l' : 'p'
          
              const imgData = canvas.toDataURL('image/png')
              const pdf = new jsPDF({
              orientation,
              //unit: 'px',
              unit: "mm",
            })
          
              /*pdf.internal.pageSize.width = componentWidth
              pdf.internal.pageSize.height = componentHeight
          
              pdf.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight)
              pdf.save('download.pdf')*/
    
              //new calculation
                const imgProps = pdf.getImageProperties(imgData);
                const margin = 0.1;
    
                const pdfWidth = pdf.internal.pageSize.width * (1 - margin);
                const pdfHeight = pdf.internal.pageSize.height * (1 - margin);
    
                const x = pdf.internal.pageSize.width * (margin / 2);
                const y = pdf.internal.pageSize.height * (margin / 2);
    
                const widthRatio = pdfWidth / imgProps.width;
                const heightRatio = pdfHeight / imgProps.height;
                const ratio = Math.min(widthRatio, heightRatio);
                
                const w = imgProps.width * ratio;
                const h = imgProps.height * ratio;
    
                pdf.addImage(imgData, "JPEG", x, y, w, h);
                var date = new Date(selectedMonthForFilter);
                pdf.save('KRA Report '+date.toLocaleString('en-us',{month:'short', year:'numeric'})+'.pdf');
                setIsLoading(false);
            })
         }
         catch(error)
         {
            setIsLoading(false);
         }
    }

    const fetchKRADashboardReport = () => {
		
		try {
            let filterParameters = {};
            var date = new Date(selectedMonthForFilter);
            var fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            if(selectedFacilitatorNameListForFilter.length==0)
            {
                toast(`Please select any Facilitator.`, {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            let facilitator_idsListtemp2 = [];
            selectedFacilitatorNameListForFilter.map((e) => {
            if(e.value!="*")
            {
                facilitator_idsListtemp2.push(e.value);
            }
            });
            const facilitator_idsList=facilitator_idsListtemp2;

            if(fromDate)
            {
                filterParameters.fromDate=fromDate;
            }

            if(toDate)
            {
                filterParameters.toDate=adjustedToDate(toDate);
            }

            if (facilitator_idsList.length) {
                filterParameters.facilitator_ids = facilitator_idsList;
            }
            let sr=filterParameters
            setIsLoading(true);
            api.getKRADashboardReport(filterParameters)
                .then(({ data }) => {
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                    window.open(data["generated_file"], "_self");
                    setIsLoading(false);
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(error["response"]["data"]["message"], {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
            } catch (error) {
                setIsLoading(false);
                toast("Server error.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
            });
        }
	};

    const fetchFacilitatorCallReport = (email) => {		
		try 
        {
            let filterParameters = {};
            if(!selectedMonthForFilter)
            {
                toast(`Please select Date.`, {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
                return;
            }
            var date = new Date(selectedMonthForFilter);
            var fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
            var toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            if(fromDate)
            {
                filterParameters.fromDate=fromDate;
            }

            if(toDate)
            {
                filterParameters.toDate=adjustedToDate(toDate);
            }

            filterParameters.facilitator_id = email;

            let sr=filterParameters
            setIsLoading(true);
            api.getFacilitatorCallReport(filterParameters)
                .then(({ data }) => {
                    setIsLoading(false);
                    toast(data["details"], {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    });
                    window.open(data["generated_file"], "_self");
                })
                .catch((error) => {
                    setIsLoading(false);
                    toast(error["response"]["data"]["message"], {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                });
            }
            catch (error)
            {
                setIsLoading(false);
                toast("Server error.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
            });
        }
	};


    return(
        <>        
        {
            activePage==="ManagersKRAView"?
            (
                <div className={`${isLoading && "set-opacity"}`} id={"root-element"}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-3">
                            <div className="admin-fkra-report-multi-select"> 
                                <MultiSelectAll
                                    toggleAll={toggleAllForFilter}
                                    toggleSelection={toggleSelectionForFilter}
                                    checkboxItemsList={FacilitatorNameListForFilter}
                                    selectedOptions={selectedFacilitatorNameListForFilter}
                                    placeholderButtonLabel={"Selected Facilitator"}
                                />
                            </div>
                            <div className="admin-fkra-report-date-picker">
                                <ReactDatePicker
                                    dateFormat="MMM/yyyy"
                                    selected={selectedMonthForFilter}
                                    onChange={(date) =>setMonthForFilter(date)}
                                    placeholderText="select Month and Year"
                                    showMonthYearPicker
                                    maxDate={new Date()}
                                />
                            </div>
                            <Button className="admin-fkra-inline-button" onClick={handleSearchClick}>Search</Button>
                            <Button className="admin-fkra-inline-button" onClick={fetchKRADashboardReport}>Export</Button>
                            {/*<Button className="admin-fkra-inline-button" onClick={onClearFilterSearch}>
                                Clear
                            </Button>*/}
                        </div>
                        <div className="col-4">
                        <Chart                            
                            width={'100%'}
                            height={'120px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    teamsPerformanceDeliveredTarget,
                                    teamsPerformanceDeliveredAchieved
                                ]
                            ]}
                            options={{
                                title: 'Delivered Services Target vs Achieved %',
                                chartArea: { left :10,width: '70%' },
                                colors:['#3366cc','#dc3912'],
                                hAxis: {
                                    title: 'Assigned Services: '+teamsPerformanceAssignedCount,
                                    minValue: 0,
                                    },
                                    vAxis: {
                                    title: '',
                                    },
                            }}
                            // For tests
                            />
                        </div>
                        <div className="col-5">
                        <Chart
                            width={'100%'}
                            height={'120px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                    teamsPerformance3plusUsersTarget,
                                    teamsPerformance3plusUsersAchieved
                                ]
                            ]}
                            options={{
                                title: 'Three+ resource availed users Target vs Achieved',
                                chartArea: {left:10 ,width: '80%' },
                                
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                        </div>
                    </div>
                    <div className="row"style={{marginTop:"20px"}}>
                        <div className="col-12 service-partner">
                        <ManagersFacilitatorKRAGrid
                            data={TableData}
                            FacilitatorData={FacilitatorData}
                            selectedFacilitatorNameListForFilter={selectedFacilitatorNameListForFilter}
                            fetchFacilitatorCallReport={fetchFacilitatorCallReport}
                        />
                        </div>
                    </div>
                </div>
            )
            :
            activePage==="No_Access"?
            (
                <div className={`row row-container`}>
                        <div className="col-12 row-margin-10px" style={{textAlign:"center"}}>                                
                        <label>
                            <b>You are not allowed to access this page, Please contact admin for more details.</b>
                        </label>         
                    </div>
                </div>
            )
            :
            (
                ""
            )}
        </>
    );
}